import React from 'react';
import ExpressStore from '@/stores/express';
import './index.less';
//ready-to-ship相关
interface PropType {
  hasLogistics: boolean;
  leadTimeInfo: TradeTypes.LeadTimeInfo;
}
export default function Rts(props: PropType) {
  const { leadTimeInfo, hasLogistics } = props;
  const { isEmpty, express } = ExpressStore((state) => state.product);

  const leadTime = Number(express.leadTime);

  const renderRts = () => <span className="selling-point detail-separator">Ready to Ship</span>;

  // 海外仓逻辑
  if (isEmpty === false) {
    if (leadTime > 0 && leadTime <= 15) {
      return renderRts();
    }
    return null;
  }

  if (hasLogistics && leadTimeInfo?.ladderPeriodList[0]?.processPeriod) {
    const { processPeriod } = leadTimeInfo.ladderPeriodList[0];
    if (processPeriod > 0 && processPeriod <= 15) {
      return renderRts();
    }
  }

  return null;
}
